import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const categories = ["Raw Material", "Finished Product", "Packaging Material"];
export const categoryLabel = { "Raw Material": "Raw materials", "Finished Product": "Finished goods", "Packaging Material": "Packaging" };
export const emptyItem = { name: "", category: "Raw Material", sku: "", quantity: "", unit: "kg", min_threshold: "", unit_cost: "", batch_number: "", supplier_or_client: "" };
export const AUTH_KEY = "sep_auth";

export const downloadChallanPdf = async (challan) => {
  try {
    const res = await axios.get(`${API}/challans/${challan.id}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url; a.download = `${challan.challan_no}.pdf`;
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
    toast.success(`${challan.challan_no}.pdf downloaded`);
  } catch (err) { toast.error("Could not download PDF"); }
};

export const downloadBlob = async (url, filename, successMessage) => {
  try {
    const res = await axios.get(url, { responseType: "blob" });
    const blobUrl = URL.createObjectURL(new Blob([res.data], { type: res.headers["content-type"] }));
    const a = document.createElement("a");
    a.href = blobUrl; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(blobUrl);
    toast.success(successMessage || `${filename} downloaded`);
  } catch (err) { toast.error("Could not generate file"); }
};
